<template>
  <div class="industry">
    <div class="dynamic">
      <div class="dynamic-left">
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <div class="dynamic-right">
        <Hotspot />
      </div>
    </div>
  </div>
</template>

<script>
import Hotspot from './components/Hotspot'

export default {
  components: { Hotspot },
  filters: {},
  data() {
    return {
      isList: true,
      isDetail: false
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.industry {
  min-height: calc(100vh - 60px);
  background-color: #f0f3fb;
  padding: 50px 0 24px;
  .dynamic {
    box-sizing: border-box;
    border-radius: 10px;
    width: 1200px;
    height: 1268px;
    margin: 0 auto;
    display: flex;
    .dynamic-left {
      flex: 1;
      background: white;
      border-radius: 10px 0 0 10px;
      overflow: hidden;
    }
    .dynamic-right {
      width: 282px;
      // height: calc(100vh - 134px);
      background: white;
      border-radius: 0 10px 10px 0;
      // position: sticky;
      // top: 110px;
    }
  }
}
</style>
